interface SectionTitleProps {
  label?: string;
  title: string;
  subtitle?: string;
  highlight?: string[];
  align?: 'left' | 'center';
}

export default function SectionTitle({
  label,
  title,
  subtitle,
  highlight = [],
  align = 'center',
}: SectionTitleProps) {
  const renderTitle = () => {
    if (highlight.length === 0) return title;
    let result = title;
    highlight.forEach((word) => {
      result = result.replace(
        word,
        `<span class="text-accent-500">${word}</span>`
      );
    });
    return <span dangerouslySetInnerHTML={{ __html: result }} />;
  };

  return (
    <div className={`mb-10 md:mb-14 ${align === 'center' ? 'text-center' : 'text-left'}`}>
      {label && (
        <span className="inline-block text-xs font-medium text-primary-500 bg-primary-100/70 px-3 py-1.5 rounded-full mb-4 font-label uppercase tracking-wider">
          {label}
        </span>
      )}
      <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading leading-tight">
        {renderTitle()}
      </h2>
      {subtitle && (
        <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
          {subtitle}
        </p>
      )}
    </div>
  );
}